import * as React from "react";
import {
    Grid,
    Button,
    Typography,
    Dialog,
    DialogTitle,
    DialogActions,
    DialogContent
} from "components/controls/widget";
import { FormControl, buildFormControlProps } from "components/controls/FormControl";
import { hasFlag } from "components/state/types";
import { useMemberValidation } from "../../../../../../member-validation/store";
import { PhoneVerificationCodeDialog } from "../../../../../../member-validation/phoneVerificationCodeDialog";
import { MemberValidationState } from "../../../../../../member-validation/entity";
import { useUIContext } from "../../../../../../context/store";
import { useMemberPhone } from "./store";
import { useMemberDetail } from "../../store";


const UpdateDialog = () => {
    const [memberState] = useMemberDetail();
    const [state, actions] = useMemberPhone();
    const [validationState, validationActions] = useMemberValidation();
    const idtClena = memberState.entity.idtClena;


    React.useEffect(() => {
        if (validationState.phoneValidationRequestSucceeded) {
            actions.changeDialogState(false);
            validationActions.showPhoneVerificationCodeDialog(true);
        }
    }, [validationState.phoneValidationRequestSucceeded]);

    React.useEffect(() => {
        actions.setErrors(validationState.errors);
    }, [validationState.loadFailure]);

    const disable = validationState.loading;

    const fieldDef = buildFormControlProps("phone", { 'phone': { label: 'Nové telefonní číslo' } }, state, actions);

    return <Dialog open={state.showDialog} scroll="paper" >
        <DialogTitle>{'Změna telefonního čísla'}</DialogTitle>
        <DialogContent>
            <FormControl {...fieldDef} autoFocus />
        </DialogContent>
        <DialogActions>
            <Button color="primary" variant="contained" onClick={() => validationActions.sendPhoneValidationRequest(idtClena, state.entity.phone)} disabled={disable}>{'Uložit a zahájit ověření'}</Button>
            <Button variant="contained" onClick={() => actions.changeDialogState(false)} disabled={disable}>{'Ponechat stávající telefon'}</Button>
        </DialogActions>
    </Dialog>;
}


const View = () => {

    const [{ entity }] = useMemberDetail();
    const [memberValidationState, validationActions] = useMemberValidation();
    const [{ showDialog }, { changeDialogState }] = useMemberPhone();
    const [uiContextState] = useUIContext();
    const validationState = memberValidationState.entity.state;
    const { showPhoneVerificationCodeDialog } = memberValidationState;
    const disable = showDialog;

    const validOrPending = hasFlag(validationState, MemberValidationState.PhoneValidAndPending);
    const pending = hasFlag(validationState, MemberValidationState.PhonePending);

    const phone = validOrPending
        ? memberValidationState.entity.phone + (pending ? " (nový, čeká na ověření)" : " (ověřeno)")
        : entity.telefon;

    const userAndMemberIdtEquals = uiContextState.data.member.userMemberIdt === entity?.idtClena;
    const showValidationControls = validOrPending && userAndMemberIdtEquals;

    return <Grid container direction="column">
        <Grid item>
            <Grid container direction="row" alignItems="center" spacing={8}>
                <Grid item>
                    {phone || 'není'}
                </Grid>
                {showValidationControls && <Grid item>
                    <Button variant="contained" size="small" onClick={() => changeDialogState(true)} disabled={disable}>{'Změnit'}</Button>
                </Grid>}
                {showValidationControls && pending && <Grid item>
                    <Button variant="contained" size="small" onClick={() => validationActions.showPhoneVerificationCodeDialog(true)} disabled={disable}>{'Vložit kód ze SMS'}</Button>
                </Grid>}
                <UpdateDialog />
            </Grid>
        </Grid>
        {showValidationControls && pending && <Grid item>
            <Typography variant="subtitle2">{'Na nové telefonní číslo jsme odeslali SMS s ověřovacím kódem. Prosíme, ověřte svůj nový telefon pomocí tlačítka Vložit kód ze SMS.'}</Typography>
        </Grid>}

        {showPhoneVerificationCodeDialog && <PhoneVerificationCodeDialog memberIdt={entity.idtClena} />}

    </Grid>

}

export {
    View as PhoneView
}